import _toLower from 'lodash/toLower';

export const getStateLabelByCountryName = country => {
    switch (_toLower(country)) {
        case 'australia':
        case 'brazil':
        case 'ethiopia':
        case 'germany':
        case 'india':
        case 'mexico':
        case 'myanmar':
        case 'nigeria':
        case 'united states':
            return 'State';
        case 'canada':
        case 'china':
        case 'indonesia':
        case 'south africa':
        case 'vietnam':
            return 'Province';
        case 'japan':
            return 'Prefecture';
        default:
            return 'State/Province';
    }
};
